<div class="dialog-content-wrapper -m-6">
  <mat-toolbar class="mat-primary m-0">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title text-xl text-black m-0"> Entity</span>
      <button mat-icon-button (click)="matDialogRef.close(['exit'])" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div mat-dialog-content class="p-4">
    <form name="entityForm" [formGroup]="entityForm" class="event-form w-100-p" fxLayout="column" fxFlex>
      @if(apiResponseErrorMessage!=null){
      <div class="message-box error mb-2 mt-6">
        <span class="custom-span-pre">{{apiResponseErrorMessage}}</span>
      </div>
    }
      <mat-form-field class="w-full">
        <mat-label>Name</mat-label>
        <input matInput type="text" placeholder="Name" formControlName="name" required />
        <mat-error>
          @if(entityForm.get('name').hasError('required')){
          <span>Name is required.</span>
        }
          @if(!entityForm.get('name').hasError('required') && entityForm.get('name').hasError('whitespace')){
          <span>Name is invalid.</span>
        }
          @if(!entityForm.get('name').hasError('required') && !entityForm.get('name').hasError('whitespace') &&  entityForm.get('name').hasError('maxlength')){
          <span> Length should not be more than 30.</span>
        }
        </mat-error>
      </mat-form-field>
      @if(isAddEntity){
      <mat-checkbox color="primary" (change)="onChangeIsCopy($event)" [checked]="isCopyFlag" class="">Is copy from existing entity? </mat-checkbox>
    }
      @if(isCopyFlag){
      <mat-form-field fxFlex="100" class="left-content mt-4">
        <mat-label>Default</mat-label>
          <input #entityAutoComplete matInput [formControl]="autoCompleteFormEntity" (input)="onInputChangedEntity($event.target.value)" [matAutocomplete]="auto" (focusout)="onFocusOutEntity()" />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnAutoComplete">
            @for(item of entityAutoCompleteList; track item){
            <mat-option (onSelectionChange)="onChangeEntity($event)"
                        [value]="item.text">
              <span> {{ item.text }}</span>
            </mat-option>
          }
            
          </mat-autocomplete>
        </mat-form-field>
      }

</form>
  </div>
  <div mat-dialog-actions class="m-0  px-4 py-0" fxLayout="row" fxLayoutAlign="end center">
    <button type="submit" class="save-button mat-primary"
            mat-raised-button
            [disabled]="!entityForm.valid"
            aria-label="Verify Code"
            (click)="submit()">
     Save
    </button>
  </div>
</div>